export const initiallyVisibleExperiences = 4;

export const experiences = [
  {
    id: "backend-insurance",
    sortDate: "2025-02",
    role: "backend developer (python) — insurance project",
    company: "Virim Infotech",
    companyUrl: "https://viriminfotech.com/",
    dates: "feb 2025 — jun 2025",
    location: "indore, india · hybrid",
    description: [
      "developed and maintained backend services in python for insurance workflows, including api design, database integration, and efficient data handling.",
      "applied ci/cd practices using github actions and automated builds/tests to support reliable deployment of new features.",
      "participated in code reviews and developed scalable backend components supporting application growth and increasing data requirements.",
    ],
  },
  {
    id: "autrs",
    sortDate: "2024-08",
    role: "software engineer",
    company: "AUTRS — Autism Technology Research Syndicate",
    companyUrl: "https://www.autrs.com/",
    dates: "aug 2024 — dec 2024",
    location: "chesterbrook, pa · virtual",
    description: [
      "worked on SEAL, a teaching platform designed to make curriculum content more accessible to educators.",
      "built the interface for teachers to input curriculum and integrated it with existing backend systems for database updates.",
      "developed backend page-direction logic that dynamically routed users using input/output ids so the correct curriculum content could be displayed.",
    ],
  },
  {
    id: "bridge-spades",
    sortDate: "2022-05",
    role: "new york university bridge & spades",
    company: "New York University",
    companyUrl: "https://www.nyu.edu/",
    dates: "may 2022 — may 2024",
    location: "new york, ny",
    roles: [
      {
        title: "president",
        dates: "may 2023 — may 2024",
        description: [
          "managed a 1,300-member student organization, overseeing budgeting, venue coordination, communication with members and the executive board, and conflict resolution.",
          "helped establish partnerships with other student organizations to organize large-scale social events and strengthen community engagement.",
        ],
      },
      {
        title: "marketing chair",
        dates: "may 2022 — may 2023",
        description: [
          "designed weekly emails, meeting invites, graphics, and social media content using tools including adobe photoshop and canva.",
          "coordinated with the executive board to advertise meetings and events and increase attendance.",
        ],
      },
    ],
  },
  {
    id: "robotic-process-automation",
    sortDate: "2023-06",
    role: "robotic process automation intern",
    company: "Virim Infotech",
    companyUrl: "https://viriminfotech.com/",
    dates: "jun 2023 — aug 2023",
    location: "india · on-site",
    description: [
      "worked with uipath and robotic process automation as part of an automation team building and deploying unattended bots for client workflows.",
      "contributed to automations that increased business-operation efficiency by approximately 80%.",
      "worked with the robotic enterprise framework, attended and unattended bots, time/event triggers, dispatcher and performer bots, screen scraping, data extraction, and invoice processing.",
    ],
  },
  {
    id: "events-assistant",
    sortDate: "2021-09",
    role: "events assistant",
    company: "New York University",
    companyUrl: "https://www.nyu.edu/",
    dates: "sep 2021 — may 2023",
    location: "new york, ny · on-site",
    description: [
      "managed logistics for university sporting events, including event setup, guest-list management, and maintaining team organization during events.",
      "helped onboard and train new employees on established event procedures and protocols.",
    ],
  },
  {
    id: "marketing-intern",
    sortDate: "2019-08",
    role: "marketing intern",
    company: "Treasure Island Mall",
    companyUrl: "https://www.nexusselecttrust.com/nexus-treasure-island",
    dates: "aug 2019 — jan 2020",
    location: "india · on-site",
    description: [
      "learned how experiential and social-media marketing strategies were developed for a major shopping mall and adapted to its audience.",
      "worked with the marketing team to help develop marketing plans and campaign ideas.",
    ],
  },
];
